import clsx from 'clsx';
import type { CSSProperties, PropsWithChildren } from 'react';

import { toRem } from '../../utils/ui';

import styles from './grid.module.scss';

const GridRoot = (props: GridProps) => {
  const { children, className, gap = 12 } = props;

  return (
    <div className={clsx(styles.grid, className)} style={{ ['--gap']: toRem(gap) } as CSSProperties}>
      {children}
    </div>
  );
};

const GridRow = (props: GridRowProps) => {
  const { children, className, col = 1 } = props;

  return (
    <div className={clsx(styles.row, styles[`col-${col}`], className)} data-col={col}>
      {children}
    </div>
  );
};

export const Grid = Object.assign(GridRoot, { Row: GridRow });

export type GridProps = PropsWithChildren<{
  gap?: number;
  className?: string;
}>;

export type GridRowProps = PropsWithChildren<{
  col?: number;
  className?: string;
}>;
